import React from "react";
import "./FilePicker.css";

interface FileUploadProps {
  accept?: string;
  name: string;
  file: File | null;
  caption: string;
  onChange: (name: string, file: File | null) => void;
  error?: boolean;
}

const FileUpload: React.FC<FileUploadProps> = ({ accept, name, file, onChange, error, caption }) => {
  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const selectedFile = e.target.files?.[0] || null;
    onChange(name, selectedFile);
  };

  return (
    <div className="picker-container">
      {!file ? (
        <label className="action-btn browse-btn">
          <img className="btn-img" src="/upload.png" alt="" />
          <input
            type="file"
            accept={accept}
            onChange={handleFileChange}
            className="hidden-input"
          />
        </label>
      ) : (
        <div className="file-actions">
          <button
            type="button"
            className="action-btn file-view-btn"
            onClick={() => {
              const fileURL = URL.createObjectURL(file);
              window.open(fileURL, "_blank");
              URL.revokeObjectURL(fileURL);
            }}
          >
            <img className="btn-img" src="/eye.png" alt="" />
          </button>
          <button
            type="button"
            className="action-btn file-remove-btn"
            onClick={() => onChange(name,null)}
          >
            <img className="btn-img" src="/delete.png" alt="" />
          </button>
        </div>
      )}
      <p className={`file-picker-caption ${error ? "error-pick" : ""}`}>{caption}</p>
    </div>
  );
};

export default FileUpload;
